import axios from 'axios'
import qs from 'qs'

export const getAnnouncements = (centerId, params) =>
  axios.get(`/api/announcement?${qs.stringify(params, { skipNulls: true })}`, { headers: { 'X-Center-Id': centerId } })
